<kendo-grid  [loading]="isLoading" [data]="documentInfos$ | async" [size]="'small'">

    <kendo-grid-checkbox-column title="">

    <ng-template kendoGridCellTemplate let-idx="rowIndex" let-document="dataItem">
        <input type="checkbox" class="large-checkbox" (change)="selectItem($event,document)"
            [ngModel]="document.isSelected" />
    </ng-template>

</kendo-grid-checkbox-column>

    <kendo-grid-column field="type" title="{{'claims-center.claimDocumentation.documentType' | translate}}">
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <app-document-info-description [documentInfo]="document"></app-document-info-description>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="name" title="{{'claims-center.claimDocumentation.name' | translate}}">
      <ng-template kendoGridCellTemplate let-document="dataItem">
          <span>{{document.name }}</span>
      </ng-template>
  </kendo-grid-column>


    <kendo-grid-column field="timestamp" title="{{'claims-center.claimDocumentation.addingDate' | translate}}" >
        <ng-template kendoGridCellTemplate let-document="dataItem">
            <div fxLayout="column">
                <span>{{document.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</span>
                <span>{{document.createdBy }}</span>
            </div>
        </ng-template>
    </kendo-grid-column>

</kendo-grid>


<kendo-dialog-actions>
    <button kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
    <button kendoButton (click)="confirm()" [primary]="true" submit>
        <span>{{'global.add' | translate}}</span>
    </button>
</kendo-dialog-actions>